// Accounting Purchases Vuex

import state from './purchaseReturnStates.js'
import * as getters from './purchaseReturnGetters.js'
import * as mutations from './purchaseReturnMutations.js'
import * as actions from './purchaseReturnActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
